/**
 * Sets equal width for all child elements
 */
export default function () {
    return {
        restrict: 'A',
        controller: ($scope, $element) => { // TODO: Separate controller from directive
            'ngInject';
            $scope.maxEqualWidth = 0;

            $scope.getMaxEqualWidth = () => $scope.maxEqualWidth;

            $scope.$watch(
                () => $element.width(),
                () => {
                    const elements = $element.children();
                    let elementWidth;


                    elements.each((index, element) => {
                        elementWidth = element.offsetWidth;

                        if (elementWidth > $scope.maxEqualWidth) {
                            $scope.maxEqualWidth = elementWidth;
                        }
                    });
                },
                true
            );
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/maxEqualWidth.js